import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsService } from '../../services/contact-us.services';
import { ContactUsModel } from '../../models/contact-us.model';
import { SiteMassageModel } from '../../models/site-massage.model';
import { SiteMassageService } from '../../services/site-massage.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-page-contact-two',
  templateUrl: './page-contact-two.component.html',
  styleUrls: ['./page-contact-two.component.css']
})

/**
 * Page Contact-Two Component
 */
export class PageContactTwoComponent implements OnInit {
contactUs:ContactUsModel[]=[]
      // Set Topbar Option
currentLang = localStorage.getItem('lang') || 'ar';

  Menuoption = 'center';
  Settingicon = true
  constructor(private modalService: NgbModal,private contactUsService:ContactUsService,private MassageService:SiteMassageService,private toastr: ToastrService,private translate : TranslateService) { }

  ngOnInit(): void {
        this.contactUsService.getAll()
    .subscribe(result=>{
      this.contactUs = result;
    })
  }
  massage:SiteMassageModel = {};
  mapView(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true })
  }
  sendMessage(){
    debugger;
    this.massage.Id = 0;
    this.MassageService.insert(this.massage)
    .subscribe(result=>{
      if(result == true){
   this.toastr.success(this.translate.instant('Your Message Sent Successfully'),this.translate.instant('Success'));
      }
this.massage = {};
    })
  }
}
